export default "/images/3ea7eb56b319bf551d315b05bb8ac8ec.avif";